import { forwardRef, useMemo } from 'react';
import { Skeleton, Typography, TypographyProps } from '@mui/material';
import { MoneyType, formatServerMoney } from '@razz-team/utils';
import { useTranslation } from 'react-i18next';

export interface MoneyProps extends Omit<TypographyProps, 'children'> {
  value: MoneyType | null | undefined;
  loading?: boolean;
  withSign?: boolean;
  startAdornment?: string;
  endAdornment?: string;
}

export const Money = forwardRef<HTMLElement, MoneyProps>(function Money(
  { value, loading, withSign, startAdornment, endAdornment, ...props },
  ref,
) {
  const { i18n } = useTranslation();
  const text = useMemo(
    () => formatServerMoney(value, { withSign, locale: i18n.language }),
    [value, i18n.language, withSign],
  );

  const children = (startAdornment ?? '') + text + (endAdornment ?? '');

  return (
    <Typography
      {...props}
      ref={ref}
      sx={[
        {
          display: loading ? 'inline-block' : props.display,
          width: loading ? '50%' : props.width,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {loading ? <Skeleton variant="text" sx={{ minWidth: '100px' }} /> : children}
    </Typography>
  );
});
